import tileTorinoPortaSusa01 from "assets/easy/AV_TORINO_PORTA_SUSA/01.jpg";
import tileTorinoPortaSusa02 from "assets/easy/AV_TORINO_PORTA_SUSA/02.jpg";
import tileTorinoPortaSusa03 from "assets/easy/AV_TORINO_PORTA_SUSA/03.jpg";
import tileTorinoPortaSusa04 from "assets/easy/AV_TORINO_PORTA_SUSA/04.jpg";
import tileTorinoPortaSusa05 from "assets/easy/AV_TORINO_PORTA_SUSA/05.jpg";
import tileTorinoPortaSusa06 from "assets/easy/AV_TORINO_PORTA_SUSA/06.jpg";
import tileTorinoPortaSusa07 from "assets/easy/AV_TORINO_PORTA_SUSA/07.jpg";
import tileTorinoPortaSusa08 from "assets/easy/AV_TORINO_PORTA_SUSA/08.jpg";
import tileTorinoPortaSusa09 from "assets/easy/AV_TORINO_PORTA_SUSA/09.jpg";
import tileTorinoPortaSusa10 from "assets/easy/AV_TORINO_PORTA_SUSA/10.jpg";
import tileTorinoPortaSusa11 from "assets/easy/AV_TORINO_PORTA_SUSA/11.jpg";
import tileTorinoPortaSusa12 from "assets/easy/AV_TORINO_PORTA_SUSA/12.jpg";
import tileTorinoPortaSusa13 from "assets/easy/AV_TORINO_PORTA_SUSA/13.jpg";
import tileTorinoPortaSusa14 from "assets/easy/AV_TORINO_PORTA_SUSA/14.jpg";
import tileTorinoPortaSusa15 from "assets/easy/AV_TORINO_PORTA_SUSA/15.jpg";
import tileTorinoPortaSusa16 from "assets/easy/AV_TORINO_PORTA_SUSA/16.jpg";
import fullImage from "assets/easy/AV_TORINO_PORTA_SUSA/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const torinoPortaSusa: ILevel = {
  difficulty: LevelDifficulties.easy,
  type: LevelTypes.station,
  name: "AV Torino Porta Susa",
  fullImage,
  successDialogContent: {
    subtitle: "Hai (ri)costruito la stazione AV TORINO PORTA SUSA",
    link: `https://www.fsitaliane.it/content/fsitaliane/it/innovazione/tecnologie-per-i-trasporti/le-principali-stazioni-av/torino-porta-susa-av.html`,
    contents: [
      {
        text: "Una ",
        isBold: false,
      },
      {
        text: "spettacolare struttura di acciaio e vetro",
        isBold: true,
      },
      {
        text:
          " immersa nel contesto urbano di Torino. Lunga 386 metri e larga 30, questa stazione rivisita i ",
        isBold: false,
      },
      {
        text: "modelli architettonici dell’800",
        isBold: true,
      },
      {
        text:
          " utilizzando paradigmi stilistici altamente innovativi e contemporanei. Una combinazione unica di bellezza e innovazione. Infatti, l’Associazione Eurosolar ha conferito il prestigioso ",
        isBold: false,
      },
      {
        text: "premio Solare Europeo 2012",
        isBold: true,
      },
      {
        text: " per la volta di copertura della stazione, che sfrutta l’",
        isBold: false,
      },
      {
        text: "energia solare",
        isBold: true,
      },
      {
        text: " per soddisfare parte del fabbisogno elettrico.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tileTorinoPortaSusa01,
    tileTorinoPortaSusa02,
    tileTorinoPortaSusa03,
    tileTorinoPortaSusa04,
    tileTorinoPortaSusa05,
    tileTorinoPortaSusa06,
    tileTorinoPortaSusa07,
    tileTorinoPortaSusa08,
    tileTorinoPortaSusa09,
    tileTorinoPortaSusa10,
    tileTorinoPortaSusa11,
    tileTorinoPortaSusa12,
    tileTorinoPortaSusa13,
    tileTorinoPortaSusa14,
    tileTorinoPortaSusa15,
    tileTorinoPortaSusa16,
  ],
};
